<template>
  <div class="auth-layout">
    <main class="auth-content">
      <slot></slot>
    </main>
  </div>
</template>

<script>
export default {
  name: 'AuthLayout'
}
</script>

<style scoped>
.auth-layout {
  min-height: 100vh;
  width: 100%;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.auth-content {
  width: 100%;
  max-width: 100%;
  padding: 20px;
}
</style> 